/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContentMasterFieldVersionView } from './ContentMasterFieldVersionView';
export type ContentMasterSaveResultView = {
    /**
     * Product key
     */
    productKey?: string;
    /**
     * S2G content_master_product UUID
     */
    contentMasterProductId?: string;
    /**
     * Channel identifier — `plattform:N` or `shop:N` (see GET /content-master/workspace-config).
     */
    source?: string;
    /**
     * Normalized language key (same convention as product views)
     */
    language?: string;
    /**
     * Wawi article id
     */
    wawiArtikelId?: number;
    /**
     * Action performed
     */
    action?: ContentMasterSaveResultView.action;
    /**
     * Product processing status after save
     */
    processingStatus?: ContentMasterSaveResultView.processingStatus;
    /**
     * Saved field versions keyed by API field name
     */
    savedFields?: Record<string, ContentMasterFieldVersionView>;
};
export namespace ContentMasterSaveResultView {
    /**
     * Action performed
     */
    export enum action {
        DRAFT = 'draft',
        APPLY = 'apply',
    }
    /**
     * Product processing status after save
     */
    export enum processingStatus {
        NEW = 'new',
        IN_PROGRESS = 'in_progress',
        DONE = 'done',
    }
}

